import React, { FC, memo } from 'react';
import { CreditNotesTable } from './CreditNotesTable';
import { TableFilterContextProvider } from 'features/TableFilter';

export const CreditNotesPage: FC = memo(() => {
  return (
    // TO DO: add tabs to show personal credit notes (refunds from our side)
    <TableFilterContextProvider>
      <CreditNotesTable />
    </TableFilterContextProvider>
  );
});

/*
  TO DO:
  Personal credit notes: 
  Second tab, same endpoint but with other creditNoteTypes in filter (PersonalCreditNoteType)
  Same filters but with other creditNoteTypes
  Add mark-as-refunded action (after backend update)
  Add export (after backend update ?)
  Create Personal credit note modal (user page) (add creditNoteItems as well) (with Vat)
  Add personal credit notes to user Profile (same as Personal Invoices) (maybe only for admin ?)
*/
